export default {
  palette: {
    primary: '#FF329B',
    primary10: 'rgba(225, 54, 133, 0.10)',
  },
};
